import { AVAILABILITIES_API } from '@fire/constants';

export const ACCOMMODATIONS_ENDPOINT_WITH_PARAMS = `${AVAILABILITIES_API}/live-prices`;
